<div class="cm-section-icon">
    <ng-content select="[cm-icon]"> </ng-content>
</div>
<div class="cm-section-title">
    <ng-content select="[cm-title]"> </ng-content>
</div>
<div class="cm-section-subtitle">
    <ng-content select="[cm-subtitle]"> </ng-content>
</div>
